<script setup lang="ts">
import type { Question } from '../calendarQuestion'
import TabsRoot from '@/components/molecules/Tabs/TabsRoot.vue'
import TabsList from '@/components/molecules/Tabs/TabsList.vue'
import TabsTrigger from '@/components/molecules/Tabs/TabsTrigger.vue'
import TabsContent from '@/components/molecules/Tabs/TabsContent.vue'
import CalendarQuestionsNavigationNew from './CalendarQuestionsNavigationNew.vue'
import CalendarQuestionsNavigationEdit from './CalendarQuestionsNavigationEdit.vue'
import { computed, ref, watch } from 'vue'

const model = defineModel<Question[]>()
const { selectingIndex } = defineProps<{
  selectingIndex: number | null
}>()

const selectedQuestion = computed<Question | null>({
  get: () => {
    if (selectingIndex === null) return null
    if (!model.value) return null
    return model.value[selectingIndex]
  },
  set: value => {
    if (selectingIndex !== null && model.value && value) {
      model.value[selectingIndex] = value
    }
  },
})

const selectedTab = ref<string>('new')

watch(
  () => selectingIndex,
  newIndex => {
    if (newIndex === null) {
      // もしselectingIndexがnullに変わったら、新規タブに変更
      // nullの場合編集タブは無効なので
      selectedTab.value = 'new'
    } else {
      // 特定の質問事項を選択したら編集タブに自動変更
      selectedTab.value = 'edit'
    }
  }
)
</script>

<template>
  <TabsRoot default-value="new" v-model="selectedTab">
    <TabsList :class="$style.tabsList">
      <TabsTrigger :class="$style.tabsTrigger" value="new">新規</TabsTrigger>
      <TabsTrigger
        :class="$style.tabsTrigger"
        value="edit"
        :disabled="selectingIndex === null"
        >編集</TabsTrigger
      >
    </TabsList>
    <TabsContent value="new" :class="$style.navigation">
      <CalendarQuestionsNavigationNew v-model="model" />
    </TabsContent>
    <TabsContent value="edit">
      <CalendarQuestionsNavigationEdit
        v-if="selectedQuestion"
        v-model="selectedQuestion"
      />
    </TabsContent>
  </TabsRoot>
</template>

<style lang="scss" module>
.navigation {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
}

.tabsTrigger {
  flex: 1;
}
</style>
